var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillLevelDonutHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill_level_donut_half"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.06298 11.2178C9.87204 11.2178 11.3386 9.75132 11.3386 7.94226C11.3386 6.1332 9.87204 4.66667 8.06298 4.66667C6.25393 4.66667 4.78739 6.1332 4.78739 7.94226C4.78739 9.75132 6.25393 11.2178 8.06298 11.2178Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 4",
    d: "M8 0C9.05058 1.2528e-08 10.0909 0.206926 11.0615 0.608964C12.0321 1.011 12.914 1.60028 13.6569 2.34315C14.3997 3.08602 14.989 3.96793 15.391 4.93853C15.7931 5.90914 16 6.94943 16 8C16 9.05058 15.7931 10.0909 15.391 11.0615C14.989 12.0321 14.3997 12.914 13.6569 13.6569C12.914 14.3997 12.0321 14.989 11.0615 15.391C10.0909 15.7931 9.05057 16 8 16L8 11.336C8.43809 11.336 8.87189 11.2497 9.27663 11.0821C9.68137 10.9144 10.0491 10.6687 10.3589 10.3589C10.6687 10.0491 10.9144 9.68137 11.0821 9.27663C11.2497 8.87189 11.336 8.43809 11.336 8C11.336 7.56191 11.2497 7.12811 11.0821 6.72337C10.9144 6.31863 10.6687 5.95087 10.3589 5.64109C10.0491 5.33132 9.68137 5.08559 9.27663 4.91794C8.87189 4.75029 8.43809 4.664 8 4.664L8 0Z",
    fill: "#164A3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLevelDonutHalf);
export default __webpack_public_path__ + "static/media/skill_level_donut_half.7aa8d71ee5549eb93c719bc75a755117.svg";
export { ForwardRef as ReactComponent };